import React, {useEffect, useState} from "react";
import {INVITATION_STATUS_CARD_MODEL, issetItem} from "../Model/Model";
import CustomCard from "../../../../../components/CustomCard";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {IconInfoCard} from "../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../components/CustomTooltip";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 */

const InvitationStatusCardContent = () => {
    const {t} = useTranslation();
    const { countAllByAllStatus } = useSelector((state) => state?.InvitationSlice);
    const [invitationStatus, setInvitationStatus] = useState({...INVITATION_STATUS_CARD_MODEL});

    useEffect(() => {
        countAllByAllStatus?.map((item) => {
            let statusId = parseInt(item.name);
            if(issetItem(invitationStatus.PENDING.list, item.identifier, statusId)) setTotal(item, invitationStatus.PENDING.id);
            if(issetItem(invitationStatus.IN_PROGRESS.list, item.identifier, statusId)) setTotal(item, invitationStatus.IN_PROGRESS.id);
            if(issetItem(invitationStatus.COMPLETED.list, item.identifier, statusId)) setTotal(item, invitationStatus.COMPLETED.id);
            if(issetItem(invitationStatus.NOT_APPROVED.list, item.identifier, statusId)) setTotal(item, invitationStatus.NOT_APPROVED.id);
        });
    }, [countAllByAllStatus]);

    const setTotal = (item, sectionId) => {
        let list = [...invitationStatus[sectionId].list];
        list = list.map(e => {
            if(e[item.identifier] === parseInt(item.name)){
                e.total = item.value;
            }
            return e;
        });

        setInvitationStatus({...invitationStatus, [sectionId]: {...invitationStatus[sectionId], list: list}})
    }

    return (
        <div className={"row d-flex mt-3"}>
            {
                Object.entries(invitationStatus).map(([key, item]) => {
                     return <>
                         <div className={`col-sm-12 col-md-6 co
                         l-lg-6 col-xl-3 col-xxl-3 mb-2 ${item.paddingCard}`}>
                             <CustomCard classCard={`${item.classCard} card-border-8px`} classContent={"px-8px py-16px"} classes="h-100">
                                 <div className={"row mb-3"}>
                                     <div className={"col-12"}>
                                         <div className={"d-flex justify-content-start align-items-center p-0"}>
                                             <p className={`${item.fontColor} ibl-font-w-700 fs-14px`}>{t(item.titleTrans)}</p>
                                         </div>
                                     </div>
                                 </div>
                                 <div className={"row"}>
                                     { item.list.map(x => {
                                         return <div className={`${x.cols} p-1`}>
                                             <CustomCard classCard={`${x.classCard} card-border-8px position-relative`} classContent={"p-0"}>
                                                 <div className={"position-absolute t-negative-4px r-3px"}>
                                                     <CustomTooltip
                                                         text={<>
                                                             <p className={"ibl-font-w-600 fs-12px"}>{t(x.titleTrans)}</p>
                                                             <p className={"fs-12px"}>{t(x.descriptionTrans)}.</p>
                                                         </>}
                                                         placement={"right"}
                                                     >
                                                         <IconInfoCard className={item?.infoColor + " w-h-14px"}/>
                                                     </CustomTooltip>
                                                 </div>
                                                 <div className={"text-center"}>
                                                     <x.Icon className="icon-color-error-code-700" />
                                                 </div>
                                                 <div className={"text-center"}>
                                                     <p className={`${item.fontColor} ibl-font-w-700 fs-24px`}>{x.total}</p>
                                                 </div>
                                             </CustomCard>
                                         </div>
                                     })}
                                 </div>
                             </CustomCard>
                         </div>
                     </>
                })
            }

        </div>
    );
};

export default InvitationStatusCardContent;
